export var SuggestionItemStyles = function SuggestionItemStyles(props) {
  return {
    closeButton: {
      background: 'transparent'
    }
  };
};
export var SuggestionsStyles = function SuggestionsStyles(props) {
  return {
    suggestionsContainer: {
      borderBottom: 'none'
    }
  };
};